import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'scandic-number-input',
  templateUrl: './scandic-number-input.component.html',
})
export class ScandicNumberInputComponent implements OnInit {
  unit: any = {
    plural: "",
    single: "",
  };

  @Input()
  min: number;
  @Input()
  max: number;
  @Input()
  ariaLabel: string;
  @Input()
  name: string;
  @Input()
  type: string = "adult";
  @Input()
  value: number;

  @Output() changed = new EventEmitter<Object>();

  constructor() { }

  ngOnInit(): void {
    if (typeof(window) != 'undefined') {
      if (window['Scandic'].bookingWidgetLabels && window['Scandic'].bookingWidgetLabels.guestSelector) {
        const guestSelector = window['Scandic'].bookingWidgetLabels.guestSelector;
        this.unit = this.type == 'adult' ? guestSelector.adultUnit : guestSelector.childUnit;
        this.value = this.value || (this.type == 'child' ? 0 : 1);
      }
    }
  }

  increment(): void {
    if (this.value < this.max) {
      this.value += 1;
    }
    this.changed.emit({
      type: this.type,
      value: this.value
    });
  }

  decrement(): void {
    if (this.value > this.min) {
      this.value -= 1;
    }
    this.changed.emit({
      type: this.type,
      value: this.value
    });
  }

  keydown(event): void {
    if (event && event.which && event.which === 38) {
      this.increment();
      event.preventDefault();
    } else if (event && event.which && event.which === 40) {
      this.decrement();
      event.preventDefault();
    }
  }
}
